import { fork } from 'redux-saga/effects';

import { httpHandler } from './http-handler';

export function* mainSaga() {
	yield fork(httpHandler);
}
